// extracted by mini-css-extract-plugin
export default {"root":"style_root__3uD+6","label":"style_label__zloAY"};